<script>
  import { tempStore } from "../../../stores/temp.store";
  import { hooksStore } from "../../../stores/hooks.store";

  import Formular from "./poznamky/Formular.svelte";

  import { viditelnostTabu } from "../sidebarLeft.func";
  import { onDocumentClick, zobrazPoznamky, zrusit } from "./poznamky.func";
  import Icon from "../../../components/Icon/Icon.svelte";
  import get from "get-value";
  import set from "set-value";
  import { get as get_store } from "svelte/store";
  import { onDestroy } from "svelte";

  let open = false;
  const kodMenu = "poznamky";
  let kreslenia = {};
  let poznamkaId;
  let sourceId;
  let formularIsOpen = false;

  const unsubscribeMenu = tempStore.subscribe((value) => {
    viditelnostMenu(value);
  });

  function viditelnostMenu(value) {
    let menu = get(value, "menu");
    open = kodMenu === menu;
  }

  hooksStore.addFilter(
    "sidebarLeft_viditelnostTabu_doCustom",
    "Poznamky.svelte",
    (excludes, typ, menu) => {
      if (typ === "poznamky" || menu === "poznamky") {
        excludes.push("poznamky");
      }
      return excludes;
    }
  );

  hooksStore.addAction(
    "sidebarLeft_viditelnostTabu",
    "Poznamky.svelte",
    (menu, typ) => {
      let store = get_store(tempStore);
      if ((typ === "poznamky" || menu === "poznamky") && formularIsOpen) {
        hooksStore.doAction("confirmDialog", {
          texts: {
            title: "Máte aktívnu editáciu poznámky.",
            text: "Zrušením editácie ostane poznámka nezmenená. \n Nové a editované kreslenia budú zmazané. \n Chcete editáciu zrušiť?",
            confirm: "Áno, zrušiť editáciu",
            cancel: "Nie, pokračovať v editovaní",
          },
          callback: () => {
            zrusit(sourceId, poznamkaId);
            set(store, "menu", null);
            tempStore.set(store);
          },
        });
      } else if (
        (typ === "poznamky" || menu === "poznamky") &&
        !formularIsOpen
      ) {
        set(store, "menu", menu === typ ? null : typ);
        tempStore.set(store);
      }
    }
  );

  onDestroy(unsubscribeMenu);
</script>

<!-- Tab map notes start -->
<div
  class="sidebar__tab sidebar__tab--map"
  data-tab="3"
  class:js-tab--open={open}
>
  <div
    class="sidebar__close"
    on:click|preventDefault={() => viditelnostTabu(kodMenu)}
  >
    <Icon kod="012" />
  </div>
  <div class="sidebar__wrapper">
    <div class="poznamky-vyber">
      <h6 class="sidebar__heading">Zobraziť poznámky v mape</h6>
      <div class="input-group">
        <!-- Toggle start -->
        <div class="toggle">
          <input
            type="checkbox"
            id="toggle1"
            value="my-private"
            on:change={(e) => zobrazPoznamky(e)}
          />
          <label class="toggle__icon" for="toggle1" />
          <label class="toggle__text" for="toggle1">Moje súkromné</label>
        </div>
        <!-- Toggle end -->
      </div>

      <div class="input-group">
        <!-- Toggle start -->
        <div class="toggle">
          <input
            type="checkbox"
            id="toggle2"
            value="my-public"
            on:change={(e) => zobrazPoznamky(e)}
          />
          <label class="toggle__icon" for="toggle2" />
          <label class="toggle__text" for="toggle2">Moje verejné</label>
        </div>
        <!-- Toggle end -->
      </div>

      <div class="input-group">
        <!-- Toggle start -->
        <div class="toggle">
          <input
            type="checkbox"
            id="toggle3"
            value="other-public"
            on:change={(e) => zobrazPoznamky(e)}
          />
          <label class="toggle__icon" for="toggle3" />
          <label class="toggle__text" for="toggle3">Verejné poznámky</label>
        </div>
        <!-- Toggle end -->
      </div>
    </div>

    <Formular {kodMenu} bind:formularIsOpen bind:sourceId bind:poznamkaId />
  </div>
</div>
<!-- Tab map notes end -->

<svelte:window on:click={onDocumentClick} />

<style lang="scss">
  .poznamky-vyber {
    margin-bottom: 50px;
  }
</style>
